import React, { useEffect, useRef, useState } from 'react';
import {
  Col,
  Row,
  Tabs,
  Tab,
  Card,
  Form,
  Button,
  Table,
} from 'react-bootstrap';
import Layout from '../../wrappers/layout';
import format from 'string-template';

import PageHeader from '../../shared/page-header';
import { useHistory, useLocation } from 'react-router-dom';
import CurrencyInput from 'react-currency-input-field';
// import { Form } from 'formik';
import './styles.css';
import RadioCard from 'pages/signup/components/radioCard';
import Faq from './faq';
import SipHttp from './sip.service';
import { useParams } from 'react-router-dom';
import { query } from 'firebase/firestore/lite';
import { makeQuery } from 'utils';
import moment from 'moment';
import SipPayMethod from 'shared/sipPayMethod/SipPayMethod';
import { userStore } from 'store/UserStore';
import buySellService from 'services/buy-sell.service';
import RedirectToast from 'shared/common/toast/redirectToast';
import { toast } from 'react-toastify';
import useRazorpay, { RazorpayOptions } from 'react-razorpay';
import dashboardService from 'services/dashboard.service';
import { dashboardStore } from 'store/DashboardStore';
import OtpPopup from 'shared/common/otp-modal/otpModal';
import {
  ACK_FAIL,
  ACK_SUCCESS,
  BUYBACK_INVOICE_UPLOAD_MESSAGE,
  OTP_SENT_TO_REG_MESSAGE,
  OTP_VERIFY_FAILURE,
  OTP_VERIFY_SUCCESS,
  TRADEMARK_LOGO_URL,
} from 'constants/messages.constant';
import Loader from 'shared/common/loader';
interface PropsType {}
interface ExtendedRazorpayOptions extends RazorpayOptions {
  config?: {
    display: RazorpayOptions['config']['display'] & {
      blocks: Record<string, any>;
      sequence: string[];
      preferences: Record<string, any>;
    };
  };
}

const PaymentSchedule: React.FC<PropsType> = () => {
  const history = useHistory();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const encodedSip = queryParams.get('data');
  const decodedSip = JSON.parse(decodeURIComponent(encodedSip));
  const [selectedTab, setSelectedTab] = useState<any>('completedsip');
  const [upcomingList, setUpcomingList] = useState<any>([]);
  const [completedList, setCompeletedList] = useState<any>([]);
  const [isDisplayPayMethod, setIsDisplayPayMethod] = useState<any>(false);
  const [loading, setLoading] = useState<any>(false);
  const abortControllerRef = useRef<AbortController>(new AbortController());
  const [metals, setMetals] = useState(null);
  const [intervalIdQuote, setIntervalIdQuote] = useState<any>('');

  const [quoteData, setQuoteData] = useState<any>({
    itemCode: decodedSip?.itemCode,
    otherItems: [],
    requestedType: decodedSip?.installmentAmt ? 'AMOUNT' : 'PRODUCT_QTY',
    requestedValue: decodedSip?.installmentAmt
      ? decodedSip?.installmentAmt
      : decodedSip?.grams,
    requestedValueAmount: decodedSip?.installmentAmt
      ? decodedSip?.installmentAmt
      : null,
    requestedValueQuantity: decodedSip?.grams ? decodedSip?.grams : null,
    uom: 'g',
  });
  const [quoteResp, setQuoteResp] = useState(null);
  const [orderSipId, setOrderSipId] = useState(null);
  const [sipOrderId, setsipOrderId] = useState(null);
  const { id }: any = useParams();
  const onChangeTab = (tab) => {
    setSelectedTab(tab);
  };
  const [customerId, user, userData, selectedAccount, customer, setCustomer] =
    userStore((state: any) => [
      state.customerId,
      state.user,
      state.userData,
      state.selectedAccount,
      state.customer,
      state.setCustomer,
    ]);

  const [paymentMethod, setPaymentMethod] = useState('UPI');
  const [summary, setSummary] = useState(null);
  const [isOTPModalShow, setIsOTPModalShow] = useState(false);
  const [otpMeta, setOtpMeta] = useState<any>({
    otpId: '',
    otp: '',
    refType: 'B2B-BUYBACK',
    expiredAt: '',
  });
  const [otpData, setOtpData] = useState<OtpData>({
    value: '',
    ackMessage: '',
    ackMessageType: 'success',
  });
  const Razorpay = useRazorpay();
  const [razorpay, setRazorpay] = useState<any>({
    customerId: customerId,
    amount: null,
    paymentMethod: 'NEBK',
  });
  const setInitialStateRazorpay = () => {
    setRazorpay({
      customerId: customerId,
      amount: null,
      transactionTypeId: 'eb-o-00333',
      paymentMethod: 'NEBK',
    });
  };

  const isPayNowFunction = async () => {
    try {
      const res: any = await SipHttp.payNowBtnFunc(id);
      if (res?.status == 200) {
      }
    } catch (err) {}
  };

  const getUpcomingList = async () => {
    try {
      const query = makeQuery({ sip_id: id, user_id: user?.userId });
      const resp = await SipHttp.getUpcomingList(query);
      if (resp?.data?.data[0]) {
        setUpcomingList(resp?.data?.data);
      }
    } catch (err) {
      console.log(err);
    }
  };
  const getCompletedList = async () => {
    try {
      const query = makeQuery({ sip_id: id, user_id: user?.userId });
      const resp = await SipHttp.getCompletedList(query);
      if (resp?.data?.data[0]) {
        setCompeletedList(resp?.data?.data);
      }
    } catch (err) {
      console.log(err);
    }
  };
  const addquoute = async (sipId, orderId) => {
    try {
      const quotedata = {
        currency: 'INR',
        ebActRef: selectedAccount?.accountId,
        items: [quoteData],

        type: 'SELL',
      };
      setLoading(true);
      const resp = await buySellService.addQuote(quotedata, user?.userId, '');
      // setPriceBreakdown(resp.data.data);
      setQuoteResp(resp?.data?.data);
      setOrderSipId(sipId);
      setsipOrderId(orderId);

      if (resp.data.data) {
        setLoading(false);
        setIsDisplayPayMethod(true);
      } else {
        setLoading(false);
        toast.error('Something went wrong');
      }
    } catch (err: any) {
      setLoading(false);
      toast.error('Something went wrong');
      console.log(err);
    }

    // console.log('quoteres', resp);
  };

  const displayPayMethod = async (sipId, orderId) => {
    addquoute(sipId, orderId);
    // setIsDisplayPayMethod(true);
  };

  const generateOtp = async (ruleType, otpId = null) => {

    // user.mobile.value

    let payload = user?.mobile?.value;

    try {
      setLoading(true);
      const res: any = await buySellService.generateOtp(
        payload,
        ruleType,
        otpId,
        user.userId
      );
      setLoading(false);
      if (res.status === 200 && res.data.data) {
        setIsOTPModalShow(true);
        setOtpMeta({
          ...otpMeta,
          otpId: res.data.data.otpId,
          expiredAt: res.data.data.expiredAt,
        });
        return toast.success(
          'OTP has been sent to your registered mobile number.'
        );
      }
    } catch (e: any) {
      setLoading(false);
      console.log(e?.data?.errors[0]?.title);
      toast.error('Something went wrong');
      return toast.error(e.data.errors[0].title);
    }
  };

  const placeOrderFunc = async (method) => {
    const payload = {
      ebQuoteRef: quoteResp?.ebQuoteRef,
      paymentMethod: method,
      is_payment_manual: true,
      sip_id: orderSipId,
      order_id: sipOrderId,
      otp: Number(otpData?.value),
      otpId:otpMeta?.otpId
    };
    try {
      setLoading(true);
      const res: any = await buySellService.placeOrder(
        payload,
        abortControllerRef.current.signal,
        user.userId
      );
      // setLoading(false);
      if (res.status === 200 && res.data.data) {
        setLoading(false);

        if (method !== 'CUSTOMER_WALLET' && method !== 'NEFT') {
          return await setPaymentGatewayConfiguration(res.data.data, method);
        } else {
          setIsOTPModalShow(false);
          resetOtpData();
          getCompletedList();
          toast.success('Order placed successfully');
        }
        // } else if (paymentMethod === 'CUSTOMER_WALLET') {
        //   generateOtp('SELL');
        // }
      }
    } catch (err) {
      console.log(err);
      toast.error('Something went wrong');
      setLoading(false);
    }
  };
  const selectSipPayMethod = async (method) => {
    setPaymentMethod('UPI');
    setIsDisplayPayMethod(false);
    // };

    // const placeOrder = async (payload) => {
    try {
      if (method === 'CUSTOMER_WALLET') {
        if (Number(summary?.walletBalance) < quoteResp.summary.quotationTotal) {
          // setLoading(false);
          return toast.error(
            <RedirectToast
              btnLabel='Go to Wallet'
              label='Wallet balance is not enough'
              showButton
              onBtnClick={() => {
                history.push('/wallet');
              }}
            />,
            { closeOnClick: false }
          );
        } else {
          generateOtp('SELL');
        }
      }

      // const payload = {
      //   ebQuoteRef: quoteResp?.ebQuoteRef,
      //   paymentMethod: method,
      //   is_payment_manual: true,
      //   sip_id: orderSipId,
      // };
      // setLoading(true);
      // const res: any = await buySellService.placeOrder(
      //   payload,
      //   abortControllerRef.current.signal
      // );
      // setLoading(false);
      // if (res.status === 200 && res.data.data) {
      //   if (method !== 'CUSTOMER_WALLET' && method !== 'NEFT') {
      //     return await setPaymentGatewayConfiguration(res.data.data, method);
      //   } else if (paymentMethod === 'CUSTOMER_WALLET') {
      //     generateOtp('SELL');
      //   }
      // }
      else {
        await placeOrderFunc(method);
      }
    } catch (err: any) {
      // setLoading(false);
      // setInitialStateItem();

      if (err.data.errors.length > 0) {
        return toast.error(err.data.errors[0].title);
      }
      return toast.error('Something went wrong');
    }
  };

  const checkPaymentStatus = async (paymentId, orderId) => {
    try {
      let payload = {
        paymentId,
        orderId,
      };
      setLoading(true);
      const res = await buySellService.checkPaymentStatus(
        payload,
        abortControllerRef.current.signal
      );
    } catch (error) {
    } finally {
      setLoading(false);
      getCompletedList();
      toast.success('Order placed successfully');
    }
  };
  const onCloseHandler: any = async () => {
    getCompletedList();
  };
  const setPaymentGatewayConfiguration = async (data, method) => {
    // setLoading(false);
    const options: ExtendedRazorpayOptions = {
      key: process.env.REACT_APP_RAZORPAY_KEY,
      amount: '',
      currency: 'INR',
      name: 'eBullion',
      description: 'Buy Metals',
      // image:
      //   'https://ebullion-dev.s3.ap-south-1.amazonaws.com/assets/eb-logo.png',
      order_id: '',
      modal: {
        ondismiss: onCloseHandler, // Assigning the onCloseHandler function
      },
      async handler(response: any) {
        setLoading(true);
        const payload = {
          customerId: razorpay.customerId,
          razorpayOrderId: response.razorpay_order_id,
          razorpayPaymentId: response.razorpay_payment_id,
          razorpaySignature: response.razorpay_signature,
          razorpayRequestBody: {
            amount: razorpay.amount,
            currency: 'INR',
            // test: 'testUPIwithRPY',
          },
        };

        // const res: any =
        //   paymentMethod === 'UPI'
        //     ? await BuySellService.verifyUPIPaymentRazorpay(payload)
        //     : await BuySellService.verifyNEBKPaymentRazorpay(payload);
        // if (res.status === 200 && res.data.data) {
        setInitialStateRazorpay();
        await checkPaymentStatus(
          response.razorpay_payment_id,
          data?.ebOrderRef
        );
        // }
      },
      prefill: {
        name: user.displayName,
        email: user.email.value,
        contact: user.mobile.value,
        method: method === 'UPI' ? 'upi' : 'netbanking',
      },
      config: {
        display: {
          language: 'en',
          blocks: {
            banks: {
              name: paymentMethod === 'UPI' ? 'Pay via UPI' : 'Pay via Net Banking',
              instruments: [
                {
                  method: paymentMethod === 'UPI' ? 'upi' : 'netbanking',
                },
              ],
            },
          },
          sequence: ['block.banks'],
          preferences: {
            show_default_blocks: false,
          },
        },
      },
      notes: {
        address: selectedAccount.billingAddress.address1,
        is_payment_manual: true,
        sip_id: orderSipId,
        order_id: sipOrderId,
      },
      theme: {
        hide_topbar: false,
        color: '#141034',
        backdrop_color: 'rgba(0, 0, 0, 0.90)',
      },
      timeout: 180,
    };

    // if (data.meta.payment.response.data.meta.length > 0) {
    //   options.order_id = data?.meta?.payment?.response.data.meta.filter(
    //     (data: any) => data.key === 'RPY_ORDER_ID'
    //   )[0].value;
    // }
    // razorpay.amount = data.meta.payment.response.data.amount;
    // options.amount = (razorpay.amount * 100).toString();
    // const razorPay = new Razorpay(options);
    // return razorPay.open();

    if (method === 'UPI') {
      if (
        data.meta.payment.response.data.meta.length > 0 &&
        data?.meta?.payment?.response.data.meta.filter(
          (data: any) => data.key === 'PAYMENT_PROVIDER'
        )[0].value === 'RPY'
      ) {
        options.order_id = data?.meta?.payment?.response.data.meta.filter(
          (data: any) => data.key === 'RPY_ORDER_ID'
        )[0].value;
        razorpay.amount = data.meta.payment.response.data.amount;
        options.amount = (razorpay.amount * 100).toString();
        const razorPay = new Razorpay(options);
        return razorPay.open();
      } else {
        setInitialStateRazorpay();
        setLoading(false);
        // await handleOrderSummaryModal(data);
      }
    }

    if (method === 'NEBK') {
      if (data.meta.payment.response.data.meta.length > 0) {
        options.order_id = data?.meta?.payment?.response.data.meta.filter(
          (data: any) => data.key === 'RPY_ORDER_ID'
        )[0].value;
      }
      razorpay.amount = data.meta.payment.response.data.amount;
      options.amount = (razorpay.amount * 100).toString();
      const razorPay = new Razorpay(options);
      return razorPay.open();

      // const res: any = await BuySellService.buyWithNEBK(razorpay);
      // if (res.status === 200 && res.data.data.notes.length > 0) {
      //   setLoading(false);
      //   options.amount = (razorpay.amount * 100).toString();
      //   options.order_id = res.data.data.notes[0].rpyOrderId;
      //   const razorPay = new Razorpay(options);
      //   return razorPay.open();
      // }
    }
  };
  const onSubmitOTP = async () => {
    try {
      setLoading(true);
      setOtpMeta({
        ...otpMeta,
        otp: otpData.value,
      });
      let payload = {
        otpId: otpMeta.otpId,
        otp: otpData.value,
      };
      const res: any = await buySellService.verifyOTP(payload, user.userId);
      setLoading(false);
      if (res.status === 200 && res.data.data) {
        setOtpData({
          ...otpData,
          value: '',
          ackMessage: OTP_VERIFY_SUCCESS,
          ackMessageType: ACK_SUCCESS,
        });
        toast.success('OTP verification successful');
        // setLoading(true);
        try {
          const res: any = await placeOrderFunc('CUSTOMER_WALLET');

          if (res?.status == 200) {
            // setLoading(false);
            setIsOTPModalShow(false);
          } else {
            setIsOTPModalShow(false);
          }
        } catch (err) {
          console.log(err);
          setIsOTPModalShow(false);
          toast.error('Something went wrong');
        }
        // handlePayment();
        // const payload = {
        //   ebQuoteRef: quoteResp?.ebQuoteRef,
        //   paymentMethod: method,
        //   is_payment_manual: true,
        //   sip_id: orderSipId,
        // };
        // // setLoading(true);
        // const res: any = await buySellService.placeOrder(
        //   payload,
        //   abortControllerRef.current.signal
        // );
      }
    } catch (e: any) {
      setLoading(false);
      setOtpData({
        value: '',
        ackMessage: OTP_VERIFY_FAILURE,
        ackMessageType: ACK_FAIL,
      });
      return toast.error(e.data.errors[0].title);
    }
  };
  const resetOtpData = () => {
    setOtpData({
      value: '',
      ackMessage: '',
      ackMessageType: 'success',
    });
  };

  const resendOTP = async (otpId: number = 0) => {
    generateOtp('SELL', otpMeta.otpId);
  };

  const getPassbookSummary = async () => {
    try {
      setLoading(true);
      const res: any = await dashboardService.getPassbookSummary(
        customerId,
        user.userId
      );
      if (res.status === 200 && res.data.data) {
        setSummary(res.data.data.summary);
        setLoading(false);
        return Promise.resolve(true);
      } else {
        setLoading(false);
        setIsDisplayPayMethod(false);
        return Promise.reject(false);
      }
    } catch (e: any) {
      console.log(e.message);
      setIsDisplayPayMethod(false);
      setLoading(false);
      return Promise.reject(false);
    }
  };

  useEffect(() => {
    const manualSipData = JSON.parse(localStorage.getItem('manualSipData'));
    if (manualSipData) {
      localStorage.removeItem('manualSipData');
    }
  }, []);
  useEffect(() => {
    getUpcomingList();
    getCompletedList();
    getPassbookSummary();
    // getMetals();
    // console.log('decodedSip:::', metals);
  }, []);

  return (
    <Layout>
      {/* <div className='pb'>
        <h2>Payment Schedule :-</h2>
        <Row>
          <Col md={12}>
            <div className='t-wrap overflow-auto'>
              <Table className='mb-0 w-100 txn__table' striped hover responsive>
                <thead>
                  <tr>
                    <th>Amount</th>
                    <th>Metal procurement</th>
                    <th>Metal Net Balance</th>
                    <th>Payment date</th>
                    <th>Payment Status</th>
                  </tr>
                </thead>
                <tbody>
                  <tr key={1}>
                    <td>100</td>
                    <td className=''>0.0345 </td>
                    <td className=''>0.0345 </td>
                    <td>
                   
                      <div className=''>{'12/11/22 '}</div>
                    </td>
                    <td className=''>{'Successful'}</td>
                  </tr>
                </tbody>
              </Table>
            </div>
          </Col>
        </Row>
      </div> */}
      {loading ? (
        <Loader />
      ) : (
        <div className='pb'>
          {/* <PageHeader
          mainTitle='Passbook'
          subTitle='All your transaction details'
          isShowSub={true}
          // isShowSub={selectedTab === 'metalTransactions'}
        /> */}

          <Row>
            <Col md={12}>
              <Tabs
                defaultActiveKey={selectedTab}
                id='uncontrolled-tab-example'
                className='mb-3'
                onSelect={onChangeTab}
              >
                <Tab eventKey='completedsip' title='Orders'>
                  {/* <h2>Payment Schedule :-</h2> */}
                  <Row>
                    <Col md={12}>
                      <div className='t-wrap overflow-auto'>
                        <Table
                          className='mb-0 w-100 txn__table'
                          striped
                          hover
                          responsive
                        >
                          <thead>
                            <tr>
                              <th>SIP Id</th>
                              <th>Order Id</th>
                              <th>Investment Amount</th>
                              <th>Payment Date</th>
                              <th>Status</th>

                              <th>Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            {completedList?.length > 0 ? (
                              <>
                                {completedList?.map((list, index) => (
                                  <tr key={index}>
                                    <td>{list?.sipId}</td>
                                    <td>{list?.orderId}</td>
                                    <td>
                                      ₹
                                      {list.installmentAmount
                                        ? list?.installmentAmount
                                        : '-'}
                                    </td>
                                    <td className=''>
                                      {moment(list?.createdAt).format(
                                        'DD-MMM-yyyy'
                                      )}
                                    </td>
                                    <td>
                                      {list?.status ? list?.status : 'PENDING'}
                                    </td>
                                    {list?.isPayButton &&
                                    list?.sipStatus == 'ACTIVE' ? (
                                      <td>
                                        <Button
                                          onClick={() =>
                                            displayPayMethod(
                                              list?.sipId,
                                              list?.orderId
                                            )
                                          }
                                          variant='primary'
                                          bsPrefix='btn-table'
                                          style={{ width: '80px' }}
                                        >
                                          Pay Now
                                        </Button>
                                      </td>
                                    ) : (
                                      <td>-</td>
                                    )}
                                  </tr>
                                ))}
                              </>
                            ) : (
                              <tr>
                                <td colSpan={6}>
                                  <div className='m-2 d-flex justify-content-center'>
                                    No data to display
                                  </div>
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </Table>
                      </div>
                    </Col>
                  </Row>
                </Tab>
                <Tab eventKey='upcoming' title='Upcoming'>
                  {/* <h2>Upcoming SIP</h2> */}

                  <Row>
                    <Col md={12}>
                      <div className='t-wrap overflow-auto'>
                        <Table
                          className='mb-0 w-100 txn__table'
                          striped
                          hover
                          responsive
                        >
                          <thead>
                            <tr>
                              <th>Id</th>
                              <th>Schedule Date</th>
                              <th>Payment Status</th>
                            </tr>
                          </thead>
                          <tbody>
                            {upcomingList?.length > 0 ? (
                              <>
                                {upcomingList?.map((list, index) => (
                                  <tr key={index}>
                                    <td>{list?.sipId}</td>

                                    <td className=''>
                                      {moment(list?.scheduleDate).format(
                                        'DD-MMM-yyyy'
                                      )}
                                    </td>
                                    <td className=''>PENDING</td>
                                  </tr>
                                ))}
                              </>
                            ) : (
                              <tr>
                                <td colSpan={4}>
                                  <div className='m-2 d-flex justify-content-center'>
                                    No data to display
                                  </div>
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </Table>
                      </div>
                    </Col>
                  </Row>
                </Tab>
              </Tabs>
            </Col>
          </Row>
          <SipPayMethod
            show={isDisplayPayMethod}
            onClick={selectSipPayMethod}
            paymentMethod={paymentMethod}
            setPaymentMethod={setPaymentMethod}
            setIsDisplayPayMethod={setIsDisplayPayMethod}
          />
          <OtpPopup
            show={isOTPModalShow}
            isLoading={loading}
            handleClose={() => {
              resetOtpData();
              setIsOTPModalShow(false);
            }}
            modalTitle={`Metal ${
              quoteData?.type === 'SELL' ? 'Purchase' : 'Sell'
            } Confirmation`}
            modalSubmitBtnText='Verify'
            onSubmit={() => onSubmitOTP()}
            otpLabel={format(OTP_SENT_TO_REG_MESSAGE, {
              suffixDigits: user?.mobile?.value?.slice(-4),
            })}
            enableResendTimer={true}
            resendHandler={() => {
              resetOtpData();
              resendOTP();
            }}
            otpChangeHandler={(value) => {
              setOtpData({
                value: value,
                ackMessage: '',
                ackMessageType: 'success',
              });
            }}
            resendButtonText='Resend OTP'
            ackMessage={otpData.ackMessage}
            ackMessageType={otpData.ackMessageType}
            numInputs={6}
            otpValue={otpData.value}
            resendInterval={30}
          />
        </div>
      )}
    </Layout>
  );
};

export default PaymentSchedule;
